import L from 'leaflet';

import icnImage from '../../../assets/map/marker/icon/icon-img.png';
import icnVideo from '../../../assets/map/marker/icon/icon-vdo.png';
import icnDam from '../../../assets/map/marker/icon/icon-dam.png';

const iconImg = new L.Icon({
  iconUrl: icnImage,
  iconSize: [20, 20],
});

const iconImageVideo = new L.Icon({
  iconUrl: icnVideo,
  iconSize: [20, 20],
});

const iconImageDam = new L.Icon({
  iconUrl: icnDam,
  iconSize: [20, 20],
});

const iconImage = {
  image: iconImg,
  video: iconImageVideo,
  dam: iconImageDam,
};

export default iconImage;
